module.exports = __webpack_public_path__ + "files/5204c28260dfd804bd7a4660e74d65bf.png";